import { handleErrors } from "../util/api-utils";

/**
 * Adds an entry to the list.
 * @param {any} request The request payload.
 * @param {function} successCallback The success callback function.
 */
export function addToList(request, successCallback, errorCallback) {
    fetch("api/Admin/AddToList", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * Updates an entry in the list.
 * @param {any} request The request payload.
 * @param {function} successCallback The success callback function.
 */
export function updateList(request, successCallback, errorCallback) {
    fetch("api/Admin/UpdateList", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * Creates or retrieves the binding authority list.
 * @param {function} successCallback The success callback function.
 * @param {function} errorCallback The error callback function.
 */
export function createOrRetrieveBindingAuthorityList(successCallback, errorCallback) {
    fetch("api/Admin/CreateOrRetrieveBindingAuthorityList", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

/**
 * Retrieves the list.
 * @param {object} params Query parameters: listType, listStatus, sob.
 * @param {function} successCallback The success callback function.
 * @param {function} errorCallback The error callback function.
 */
export function retrieveList(params, successCallback, errorCallback) {
    const query = new URLSearchParams(params).toString();
    fetch(`api/Admin/RetrieveList?${query}`, {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}
